'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactRedux = require('react-redux');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    NotFoundDecorator: {
        displayName: 'NotFoundDecorator'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/helpers/NotFoundDecorator/index.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var NotFoundDecorator = _wrapComponent('NotFoundDecorator')((_dec = (0, _reactRedux.connect)(function (state) {
    return { show_404: state.error.is_show_404, server_not_found: state.error.server_not_found };
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(NotFoundDecorator, _Component);

    function NotFoundDecorator() {
        (0, _classCallCheck3.default)(this, NotFoundDecorator);
        return (0, _possibleConstructorReturn3.default)(this, (NotFoundDecorator.__proto__ || (0, _getPrototypeOf2.default)(NotFoundDecorator)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotFoundDecorator, [{
        key: 'render',
        value: function render() {
            if (this.props.show_404) {
                return _react3.default.createElement(_containers.NotFound, null);
            } else if (this.props.server_not_found) {
                return _react3.default.createElement(_containers.NotFoundServer, null);
            }

            return this.props.children;
        }
    }]);
    return NotFoundDecorator;
}(_react2.Component)) || _class));

exports.default = NotFoundDecorator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/NotFoundDecorator/index.js
// module id = 1857
// module chunks = 0